import script from "./GuestFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestFooter.vue?vue&type=script&setup=true&lang=js"

import "./GuestFooter.vue?vue&type=style&index=0&id=0f7efdad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f7efdad"]])

export default __exports__